export default "__VITE_ASSET__D8GBm0kL__"